var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.klass,attrs:{"title":_vm.$t(_vm.description),"data-test":"tile"}})}
var staticRenderFns = []

export { render, staticRenderFns }